<script setup lang="ts">

</script>

<template>
	<div class="top-tabsView_menuDelimeter"></div>
</template>

<style>
.top-tabsView_menuDelimeter {
	padding: var(--top-padding-1) 0;
	display: flex;
}

.top-tabsView_menuDelimeter:before {
	content: "";
	height: 2px;
	background: var(--color-line-2);
	flex-grow: 1;
}

.top-tabsView_menuDelimeter:first-child,
.top-tabsView_menuDelimeter + .top-tabsView_menuDelimeter {
	display: none;
}
</style>
